/**
 * Safely serialize structured data for JSON-LD script tags.
 * Escapes `</` sequences to prevent script tag breakout attacks.
 */
export function safeJsonLd(data) {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}
